// extracted by mini-css-extract-plugin
var _1 = "SettingsButton__button--M8jn_";
var _2 = "SettingsButton__measuredEl--QyzBJ";
export { _1 as "button", _2 as "measuredEl" }
